import { BaseModel } from '../../_base/crud';

export class DrugGroup extends BaseModel {
  id: number;
  name: string;
  copay_assistance: string;
  copay_assistance_url: string;
  note: string;
  is_active: boolean;

  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
